
import React, { useState,useEffect } from 'react';
import ReactQuill from 'react-quill';
import { useNavigate } from 'react-router-dom';
import 'react-quill/dist/quill.snow.css';
import { uploadImages } from '../../../api';
const Editor = ({ onSave, type, setCurrentType }) => {
    const [title, setTitle] = useState('');
    const [author, setAuthor] = useState('');
    const [content, setContent] = useState('');
    const [images, setImages] = useState([]);
    const [imageUrls, setImageUrls] = useState([]);
    const navigate = useNavigate(); // useNavigate 훅 사용
  
    useEffect(() => {
      setCurrentType(type);
    }, [type, setCurrentType]);
  
    const handleSave = async () => {
      try {
        if (images.length > 0) {
          const uploadedImages = await uploadImages(images);
          setImageUrls(uploadedImages.imageUrls);
        }
        await onSave({ title, author, content, imageUrls });
        navigate(`/Customerservice/${type}`); // 저장 후 해당 게시판 목록으로 이동
      } catch (error) {
        console.error('Error saving post:', error);
      }
    };
  
    const handleImageChange = (e) => {
      setImages([...e.target.files]);
    };
  
    return (
      <div>
        <input 
          type="text" 
          placeholder="Title" 
          value={title} 
          onChange={(e) => setTitle(e.target.value)} 
        />
        <input 
          type="text" 
          placeholder="Author" 
          value={author} 
          onChange={(e) => setAuthor(e.target.value)} 
        />
        <ReactQuill value={content} onChange={setContent} />
        <input type="file" multiple onChange={handleImageChange} />
        <button onClick={handleSave}>Save</button>
      </div>
    );
  };
export default Editor;
